import {Injectable, inject} from '@angular/core'
import moment from 'moment'
import {SessionService} from '@uve-solutions/composition/session'
import {TranslocoService} from '@uve-solutions/composition/translate'
import 'moment/locale/ca'
import 'moment/locale/de'
import 'moment/locale/es'
import 'moment/locale/fr'
import 'moment/locale/it'
import 'moment/locale/pt'
import 'moment/locale/zh-cn'

const MOMENT_LOCALE_BY_LANG: Record<string, string> = {zh: 'zh-cn'}

// Importar ficheros de locale de moment deja activo el último importado
moment.locale('en')

@Injectable({providedIn: 'root'})
export class UveI18nService {
  readonly #session = inject(SessionService)
  readonly #transloco = inject(TranslocoService)

  init(): void {
    const lang = this.#session.currentSession()?.language || 'en'
    this.#transloco.setActiveLang(lang)
    this.#setMomentLocale(lang)

    this.#transloco.langChanges$.subscribe(newLang => this.#setMomentLocale(newLang))
  }

  #setMomentLocale(lang: string): void {
    moment.locale(MOMENT_LOCALE_BY_LANG[lang] ?? lang)
  }
}
